import { Stack } from '@fluentui/react';
import React, { useEffect } from 'react';

// assets

import { useStore } from '../../../stores/root';
import ShipsList from '../../../components/operationals/ships/general/list';
import { faHome } from '@fortawesome/pro-light-svg-icons';

interface IShipsListPageProps {
}

const ShipsListPage: React.FC<IShipsListPageProps> = (props: IShipsListPageProps) => {
    const {topbar} = useStore();

    useEffect(() => {
        topbar.show("Ships", [
            {key: "home", icon: faHome, href: "/"},
            {key: "operationals", text: 'Operationals'},
            {key: "ships", text: 'Ships'}
        ])
    }, []);

    return <Stack>
        <ShipsList />
    </Stack>;
};

export default ShipsListPage;
